import defaultAvatar from "../../assets/Logos/defaultAvatar.jpg";

/**
 * Avatar.js
 * Profile Picture component
 * @param {URL} src             -   Image URL
 * @param {String} alt          -   Alt text for the image
 * @returns 
 */
export default function Avatar({ src, alt }) {
    return (
        <div className="h-10 w-10 rounded-full bg-zinc-200 overflow-hidden flex items-center justify-center">
            {src ? 
                <img src={src} alt={alt} className="h-full w-full object-cover" /> 
            : 
                <img src={defaultAvatar} alt={alt} className="h-full w-full object-cover" />
            }
        </div>
    );
}
